import { LoginResponseInterface } from '@interface/auth/login.interface';
import { BaseStoreInterface } from '@interface/store/base-store.interface';
import { BaseStoreStructure } from '@util/constants/store.constants';

export const initialAuthState = (token: string | null = ''): BaseStoreInterface<LoginResponseInterface> => ({
  ...BaseStoreStructure,
  data: {
    token: token ?? '',
    mfa: false,
  },
});
